<a class="d-flex flex-row" (click)="click.emit($event)">
  <label>
    <input type="checkbox" [checked]="true" class="my-1 align-self-stretch"/>
    <span class="filter-value pl-1 text-capitalize">{{label}}</span>
  </label>
</a>
